import { useCRUDList } from '@/shared/hooks/useCRUDList';
import { providerCompanyService } from '@/services/providerCompany.service';

interface ProviderCompany {
  id: string;
  name: string;
  shortName: string;
  cnpj: string;
  email: string;
  phoneNumber?: string;
  postalCode: string;
  street: string;
  number: string;
  complement?: string;
  district: string;
  state: string;
  city: string;
  allowsDemandReceiving: boolean;
}

const providerCompanyServiceAdapter = {
  getAll: () => providerCompanyService.getAllProviderCompanies(),
  delete: (id: string) => providerCompanyService.deleteProviderCompany(id),
};

export function useProviderCompanyList() {
  const {
    items: providers,
    loading,
    handleNew,
    handleEdit,
    handleDelete,
  } = useCRUDList<ProviderCompany>({
    service: providerCompanyServiceAdapter,
    entityName: 'prestadora',
    routes: {
      new: '/vendor-register',
      edit: (id) => `/vendor-edit/${id}`,
    },
    messages: {
      loadError: 'Erro ao carregar prestadoras',
      deleteSuccess: 'Prestadora excluída com sucesso!',
      deleteError: 'Erro ao excluir prestadora',
    },
  });

  return {
    providers,
    loading,
    handleNew,
    handleEdit,
    handleDelete,
  };
}
